import auth from './authReducer'
import conversation from './conversationReducer'
import { project } from './projectReducer'
import availabilities from './availabilitiesReducer'
import queueList from './queueListReducer'
import store from './storeReducer'
import leadSchemeList from './leadSchemeListReducer'

export default { auth, conversation, project, availabilities, store, queueList, leadSchemeList }